import api from '../../api';

const path = '/rent/all';

export const getRentAllRequest = (id) => api.get(`${path}/get/${id}`);
export const getRentAllListRequest = (params) =>
    api.get(`${path}/get`, { params });
